/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useMemo, useState } from 'react';
import twitter from '../assets/twitter-.png';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import logoPic from '../assets/logo.jpg';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';
import Footer from '../components/footer';
import banner from '../assets/banner.png';
import line from '../assets/line.png';
import line2 from '../assets/line2-2.png';
import line2_3 from '../assets/line2-3.png';
import line3 from '../assets/line3.jpg';
import back from '../assets/back.png';
import correct from '../assets/check-mark.png';
import warning from '../assets/warning.png';
import $ from 'jquery';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork, useDisconnect } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import Story from '../components/story';
import Countdown from 'react-countdown';
import Steps from '../components/steps';
import Intro from '../components/intro';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { pulsechainV4 } from 'viem/chains';

import contractRaffle from '../contractData/contractRaffle.json';
import contractToken from '../contractData/contractToken.json';

var Scroll = require('react-scroll');

$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2000);
});

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	/*	if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {*/
	// Render a countdowns

	if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

		window.location.reload(true);
		console.log("Mint Begins");
	}


	return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
	/*	}*/
};

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const tweet = () => {
	window.open("#");
}

const discord = () => {
	window.open("#");
}

const os = () => {
	window.open("#");
}

const address = contractRaffle.address;
const ABI = contractRaffle.abi;

const addressToken = contractToken.address;
const ABIToken = contractToken.abi;


const CreateRaffle = () => {

	const { open } = useWeb3Modal()
	const { chain } = useNetwork()
	const { switchNetwork } = useSwitchNetwork()

	const { address: walletAddress } = useAccount({
		async onConnect() {
			handleConnect()
		}
	})

	const publicClient = createPublicClient({
		chain: pulsechainV4,
		transport: http()
	})

	const [_totalSupply, settotalSupply] = useState(0)
	const [statusError, setStatusError] = useState("")
	const [statusLoading, setStatusLoading] = useState("")
	const [success, setSuccess] = useState("")
	const [nftMintingAmount, setnftMintingAmount] = useState(1)
	const [_publicMintMsg, set_publicMintMsg] = useState("Mint Here")
	const [_cost, set_publicSaleCost] = useState("")
	const [_wlcost, set_wlcost] = useState("")
	const [_max_per_wallet, set_max_per_wallet] = useState(10)
	const [_owner, set_owner] = useState("")
	const [myNFTWallet, setmyNFTWallet] = useState(0)
	const [_whitelist_mint_status, set_whitelist_mint_status] = useState("")
	const [_public_mint_status, set_public_mint_status] = useState("")
	const [_whitelistLimitPerWallet, set_whitelistLimitPerWallet] = useState("")
	const [_whitelistCount, set_whitelistCount] = useState("")
	const [_whitelistLimit, set_whitelistLimit] = useState("")
	const [_MAX_SUPPLY, set_MAX_SUPPLY] = useState("")
	const [_navbarOpen, set_navbarOpen] = useState(0)
	const [_register, set_register] = useState(0)
	const [_connected, setConnected] = useState(false)
	const [_freeMinLimit, set_OverallFreeMintLimit] = useState(600);
	const [_stateNow, set_stateNow] = useState(Date.now());

	const options = countryList().getData();
	const [txnHash, setTxnHash] = useState("");
	const [_ErrorMsg1, setErrorMsg1] = useState("");
	const [showErrorDiv, setShowErrorDiv] = useState(false);
	const [_name, setName] = useState("");
	const [_Country, setCountry] = useState('');
	const [_CountryLabel, setCountryLabel] = useState('');

	const { disconnect } = useDisconnect();

	/*const changeHandler = (selectedOption) => {
		console.log("selectedOption : " + selectedOption);
		setCountry(selectedOption.label); // Store only the label
	};*/

	const changeHandler = (country) => {
		console.log("selectedOption : " + country.label);

		setCountry(country);
		setCountryLabel(country.label)
	};

	async function openR() {
		set_register(1);
	}

	async function closeR() {
		set_register(0);
	}

	async function closNotifications() {
		setShowErrorDiv(false);
		setStatusError(false);
	}

	async function closeNotificationsSuccess() {
		setSuccess(false);
		window.location.reload(true);
	}

	async function closeNav() {
		set_navbarOpen(0);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	//........................................//
	const contract = {
		address: address,
		abi: ABI
	}

	const contracToken = {
		address: addressToken,
		abi: ABIToken
	}

	async function handleConnect() {
		if (chain.id !== 943) {
			switchNetwork(943)
		}

		setConnected(true);
	}

	/*const { refetch: getTotalSupply } = useContractRead({
		...contract,
		functionName: 'totalSupply',
	})

	const { refetch: getBalance } = useContractRead({
		...contract,
		functionName: 'balanceOf',
		args: [walletAddress ? walletAddress : '0x']
	})*/


	/*useEffect(() => {


		if (_connected) {
			fetchData();
			fetchData2();
		}

		// eslint-disable-next-line no-use-before-define
	}, []);*/

	const { writeAsync } = useContractWrite({
		...contract,
		//	functionName: 'mint',
		onError(error) {
			if (error.message.includes('balance')) {
				setStatusError(true)
				setStatusLoading(false)
			}
		}
	})

	async function disconnectWallet() {
		setConnected(false);
		disconnect();
		//window.location.reload(true);
	}

	function shortenAddress(walletAddress) {
		try {
			return _connected
				? walletAddress.slice(0, 3) + "..." + walletAddress.slice(-4)
				: "Connect";
		} catch (error) {
			console.log(error);
		}
	}

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderRadius: '5px',
			borderColor: '#ccc',
			padding: '5px',
			margin: '10px 0',
			textAlign: 'left',
			boxShadow: state.isFocused ? `0 0 0 2px rgb(255, 195, 29)` : 'none', // Outline color on focus
			border: state.isFocused ? '1px solid rgb(255, 195, 29)' : '1px solid #ccc', // Border color change on focus
		}),
		placeholder: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		singleValue: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		menu: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
		option: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
	};

	async function register() {
		try {
			setStatusLoading(true);

			const res = await writeAsync({
				...contract,
				functionName: "registerUser",
				args: [_name, 'Albania'],
				//gas: 2100000,
				//gasPrice: 160000000000
			});

			const txnHash = res.hash;
			setTxnHash(txnHash);
			console.log("Transaction hash:", txnHash);

			await new Promise((resolve) => setTimeout(resolve, 3000));

			// Wait for transaction receipt
			const result = await publicClient.waitForTransactionReceipt(res);

			console.log("Transaction result:", result);

			if (result.status === "success") {
				setStatusError(false);
				setSuccess(true);
				set_register(0);
				setStatusLoading(false);

			} else if (result.status) {
				setSuccess(false);
				setStatusError(true);
				setStatusLoading(false);
			}
		} catch (e) {
			console.error("Transaction failed:", e);
			if (e.message.includes("Transaction with hash")) {
				console.log("adkiuyhsalofdjalkhfjdalskhf");
			}
			if (e.message.includes("err: insufficient funds for gas")) {
				setErrorMsg1("Insufficient funds");
				setShowErrorDiv(true); // Show the error div for insufficient funds
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			} else if (e.message.includes("User rejected the request")) {
				setErrorMsg1("User Rejected");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			} else {
				setErrorMsg1("Sorry, something went wrong");
				setShowErrorDiv(false);
				setStatusLoading(false);
				setSuccess(false);
				setStatusError(false);
			}

			setStatusError(true);
			setStatusLoading(false);
		}
	}


	return (
		<div class="allWrap">
			<div class="light">
				<div class="cont">
					{_navbarOpen < 1 ?
						(<div class="miniBarMain">
							<div className='loginDiv'><img className='logoPic' onClick={() => window.location.href = 'Raffle'} src={logoPic} /></div>

							<div className='loginDiv'><button className='login' onClick={openR}>Register</button><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
						</div>) :
						(<div class="miniBarMain">
							<img className='logoPic' onClick={() => window.location.href = 'Raffle'} src={logoPic} />

							<div className='loginDiv'><button className='login' onClick={openR}>Register</button><img class="navbar" onClick={closeNav} src={wrong} /></div>

						</div>)}

					<div class="headers">

						<div class="h1">

							<div class="connect">
								<div ><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>About</Link></div>
								<div ><Link activeClass="" id="fontSize" to="raffles" spy={true} smooth={true} duration={550}>Raffles</Link></div>
								<div ><Link activeClass="" id="fontSize" to="process" spy={true} smooth={true} duration={550}>Process</Link></div>
								<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
							</div>

							<div class="logoDiv"><img onClick={() => window.location.href = 'Raffle'} src={logoPic} /></div>
							<div class="right">

								<div class="socialIcon">
									<img src={facebook} />
									<img src={instagram} />
									<img src={twitter} />
									<img src={whatsapp} />
								</div>

								<button className='login' onClick={openR}>Register</button>

							</div>

						</div>

					</div>

					{_navbarOpen > 0 ?
						(<div class="littleNav">
							<div class="connect">
								<div ><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>About</Link></div>
								<div ><Link activeClass="" id="fontSize" to="raffles" spy={true} smooth={true} duration={550}>Raffles</Link></div>
								<div ><Link activeClass="" id="fontSize" to="process" spy={true} smooth={true} duration={550}>Process</Link></div>
								<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
							</div>

							<div class="socialIcon">
								<img src={facebook} />
								<img src={instagram} />
								<img src={twitter} />
								<img src={whatsapp} />
							</div>

						</div>) : null}
				</div>

				<form class="raffle-form" id="raffleForm" onsubmit="handleRaffleSubmit(event)">

					<div class="form-group">
						<label for="name">Raffle Name</label>
						<input type="text" id="name" name="name" required placeholder="Enter the name of the raffle" />
					</div>

					<div class="form-group">
						<label for="tagline">Tagline</label>
						<input type="text" id="tagline" name="tagline" required placeholder="Enter a catchy tagline" />
					</div>

					<div class="form-group">
						<label for="endTime">Raffle End Time</label>
						<input type="datetime-local" id="endTime" name="endTime" required />
					</div>

					<div class="form-group">
						<label for="ticketPrice">Ticket Price (in Ether)</label>
						<input type="number" id="ticketPrice" name="ticketPrice" required step="any" placeholder="Enter the ticket price" />
					</div>

					<button type="submit" class="submit-btn">Create Raffle</button>
				</form>


				{_register > 0 ?
					<div className="popup-overlay">
						<div className="popup-container">
							<div className='closeR' onClick={closeR}>✖</div>

							<div className='regsiterH'>Register</div>
							{_connected ?
								<div className='regsiterH2' onClick={() => disconnectWallet()}>{shortenAddress(walletAddress)}</div>
								: null}

							<div class="form-group">
							<div className='name'>Namea</div>

								<input id="inputR" placeholder='Jane Doe'
									onChange={(e) => {
										setName(e.target.value);
									}}
									value={_name}
								></input>

							</div>

							<Select
								options={options}
								name="_Country" value={_Country}
								onChange={changeHandler}
								placeholder="Select your country"
								styles={customStyles} // Apply custom styles		
								id="selectSection"

							/>

							{_connected ?
								<button className='submit' onClick={register}>SUBMIT</button> :
								<button className='submit' onClick={() => { open(); }}>Connect</button>}

						</div>
					</div> : null}

				{success ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closeNotificationsSuccess}>✖</div>
							<img className='correct' src={correct} />
							<div className='notificationHMsg'>Registered Successfully</div>
						</div>
						<div className='raffleCreate' onClick={() => window.location.href = 'create-raffle'}>Now you can create raffles <img src={back} /></div>

					</div> : null}

				{statusError ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>Sorry Something went wrong</div>
							<div className='notificationH2' id="error">Please try again</div>
						</div>
					</div> : null}

				{statusLoading ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div class="loader"></div>
							<div className='notificationHMsg'>Loading</div>
						</div>
					</div> : null}

				{showErrorDiv ?
					<div className="popup-overlay2">
						<div className="popup-container">
							<div className='closeR' onClick={closNotifications}>✖</div>
							<img className='correct' src={warning} />
							<div className='notificationHMsg'>Insufficent Funds</div>
							<div className='notificationH2' id="error2">Please fill your wallet</div>
						</div>
					</div> : null}

				<img className='line2' src={line3} />

				<Footer />

			</div >
		</div >
	)

}
export default CreateRaffle;
